// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M25-m","toggleWrap":"styles_toggleWrap__1vpYg","content":"styles_content__1pfJJ","selectAreaCode":"styles_selectAreaCode__2VFVg"};